
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartKNLVpJrpy5XuyXL_45MqWGhEdST8JhJEmC4vdA02O_2gkMeta } from "/root/zhubao-pc/pages/cart.vue?macro=true";
import { default as testd9uDWi2doWc9SNsZyj2mGMlIDwC5MiNKtUUcJi3Fbd8Meta } from "/root/zhubao-pc/pages/test.vue?macro=true";
import { default as indexU73Dj1JBhoPrM5dOWAqOHAY00d2xlDOiragoeEXiOCYMeta } from "/root/zhubao-pc/pages/index.vue?macro=true";
import { default as loginKKfr_458EoEbpqSAqa8jBfgu3yPVj_45yeAnQAba7g90N1IMeta } from "/root/zhubao-pc/pages/login.vue?macro=true";
import { default as forgetVxU8jpBd_GaFkCu3vAPdTuqb_45q6mpi_RbIf8zr_kdcwMeta } from "/root/zhubao-pc/pages/forget.vue?macro=true";
import { default as registerxbzxDd9CZ7jtS4oRWH1MeY2M6lCt2j7vanKr5rWyT2gMeta } from "/root/zhubao-pc/pages/register.vue?macro=true";
import { default as _91id_93fMICxqzXY3iSx081flD4X5AscBFBpEu3Egd7Pc7X7KQMeta } from "/root/zhubao-pc/pages/news/[id].vue?macro=true";
import { default as _91id_93GhugPKL_45eVE7JtRRySnqNau8wOVsEqDhnC76EYs3bokMeta } from "/root/zhubao-pc/pages/goods/[id].vue?macro=true";
import { default as aboutwyxwKAzW3LIzWqsaz_45f579m21U1dPcWcdWqibZcVpkQMeta } from "/root/zhubao-pc/pages/help/about.vue?macro=true";
import { default as login_45codehJGjjj4Jjs4pkAS4QkoB_450y5jvC007TwZs53tu1z1NwMeta } from "/root/zhubao-pc/pages/login-code.vue?macro=true";
import { default as indexrE5Sq9T0a6hD65wNPBvd4wKbePmrmlSFxmmEQL1Dr7IMeta } from "/root/zhubao-pc/pages/news/index.vue?macro=true";
import { default as indexxlee_Y05lzXkDk1dKLw7USCiarxdN6fllh0szrbZyasMeta } from "/root/zhubao-pc/pages/goods/index.vue?macro=true";
import { default as ordersxgxtHfXvxRBplnDxD24CENDjwiTeiP3JUd9biEl7npIMeta } from "/root/zhubao-pc/pages/user/orders.vue?macro=true";
import { default as contactoNiWTQnWL9oZpThsRKSG_45NHJf1ciPOjxxrt4QGg1pboMeta } from "/root/zhubao-pc/pages/help/contact.vue?macro=true";
import { default as indexMrKpqF22OI6QQdIFq9gzSnQY1ThgneycwOBCY1MM8AcMeta } from "/root/zhubao-pc/pages/search/index.vue?macro=true";
import { default as addressE4H1bJswYQKhlZP4egI_v45PehNumoPvZrwc9_v7UAoMeta } from "/root/zhubao-pc/pages/user/address.vue?macro=true";
import { default as profileu05d5tttIrtCBAbf4aJ6lKoteMm_45zRw05oLVDhei0o8Meta } from "/root/zhubao-pc/pages/user/profile.vue?macro=true";
import { default as index8wFM3_3fWyq_451IzdeJd3qPQsVbyZbavdj5eCEatoQPYMeta } from "/root/zhubao-pc/pages/newList/index.vue?macro=true";
import { default as resultqlShEbW7gl59dcHN8noszss7Gu5FhXMr4D4brtp3ASMMeta } from "/root/zhubao-pc/pages/search/result.vue?macro=true";
import { default as order_45detail4JMyhsLoNExXSrNdERHXQiw86Rvt_45lXTBhPOwuzyzGwMeta } from "/root/zhubao-pc/pages/user/order-detail.vue?macro=true";
export default [
  {
    name: "cart",
    path: "/cart",
    component: () => import("/root/zhubao-pc/pages/cart.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/root/zhubao-pc/pages/test.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexU73Dj1JBhoPrM5dOWAqOHAY00d2xlDOiragoeEXiOCYMeta || {},
    component: () => import("/root/zhubao-pc/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKKfr_458EoEbpqSAqa8jBfgu3yPVj_45yeAnQAba7g90N1IMeta || {},
    component: () => import("/root/zhubao-pc/pages/login.vue")
  },
  {
    name: "forget",
    path: "/forget",
    meta: forgetVxU8jpBd_GaFkCu3vAPdTuqb_45q6mpi_RbIf8zr_kdcwMeta || {},
    component: () => import("/root/zhubao-pc/pages/forget.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerxbzxDd9CZ7jtS4oRWH1MeY2M6lCt2j7vanKr5rWyT2gMeta || {},
    component: () => import("/root/zhubao-pc/pages/register.vue")
  },
  {
    name: "news-id",
    path: "/news/:id()",
    component: () => import("/root/zhubao-pc/pages/news/[id].vue")
  },
  {
    name: "goods-id",
    path: "/goods/:id()",
    component: () => import("/root/zhubao-pc/pages/goods/[id].vue")
  },
  {
    name: "help-about",
    path: "/help/about",
    component: () => import("/root/zhubao-pc/pages/help/about.vue")
  },
  {
    name: "login-code",
    path: "/login-code",
    meta: login_45codehJGjjj4Jjs4pkAS4QkoB_450y5jvC007TwZs53tu1z1NwMeta || {},
    component: () => import("/root/zhubao-pc/pages/login-code.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/root/zhubao-pc/pages/news/index.vue")
  },
  {
    name: "goods",
    path: "/goods",
    component: () => import("/root/zhubao-pc/pages/goods/index.vue")
  },
  {
    name: "user-orders",
    path: "/user/orders",
    component: () => import("/root/zhubao-pc/pages/user/orders.vue")
  },
  {
    name: "help-contact",
    path: "/help/contact",
    component: () => import("/root/zhubao-pc/pages/help/contact.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/root/zhubao-pc/pages/search/index.vue")
  },
  {
    name: "user-address",
    path: "/user/address",
    component: () => import("/root/zhubao-pc/pages/user/address.vue")
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () => import("/root/zhubao-pc/pages/user/profile.vue")
  },
  {
    name: "newList",
    path: "/newList",
    component: () => import("/root/zhubao-pc/pages/newList/index.vue")
  },
  {
    name: "search-result",
    path: "/search/result",
    component: () => import("/root/zhubao-pc/pages/search/result.vue")
  },
  {
    name: "user-order-detail",
    path: "/user/order-detail",
    component: () => import("/root/zhubao-pc/pages/user/order-detail.vue")
  }
]